import { ProductDivisionUpdatePage } from "@/features/product-division/pages/ProductDivisionUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-division/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_division.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDivisionUpdatePage,
});
